import { Supporter } from '@/types';
import { Box, Checkbox, FormControlLabel, FormHelperText, Typography } from '@mui/material';

type DeleteFromListAccordionContentProps = {
  deleteFromListChecked: boolean;
  onDeleteFromListCheckedChange: (checked: boolean) => void;
  listCount: number;
  selectedContacts?: Supporter[];
};

export default function DeleteFromListAccordionContent({
  deleteFromListChecked,
  onDeleteFromListCheckedChange,
  listCount,
  selectedContacts,
}: DeleteFromListAccordionContentProps) {
  const canDeleteFromList =
    deleteFromListChecked &&
    selectedContacts !== undefined &&
    selectedContacts.filter((contact) => !['Uncalled', 'Skipped'].includes(contact.callingStatus))
      .length === 0;

  const listWillBeDeleted = selectedContacts?.length === listCount;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: '16px'
      }}>
      <Typography>
        Contacts will be removed from this list only. They will remain in the database.
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={deleteFromListChecked}
            onChange={(_, checked) => onDeleteFromListCheckedChange(checked)}
          />
        }
        label="Delete selected contacts from list"
      />
      {deleteFromListChecked && !canDeleteFromList && (
        <FormHelperText error>
          One or more selected contacts have a calling status recorded for this list.
        </FormHelperText>
      )}
      {deleteFromListChecked && canDeleteFromList && listWillBeDeleted && (
        <FormHelperText error>Deleting all contacts will also delete this list.</FormHelperText>
      )}
    </Box>
  );
}
